module.exports = __webpack_public_path__ + "static/media/clear.b6a309a2.svg";